import type { IconData } from '@stacksjs/iconify-core'

export const mediaStepBackward: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M402.8 90.58a23.88 23.88 0 0 0-25.082 2.149L183.155 236.847a24 24 0 0 0 0 38.57l194.56 144.119A24 24 0 0 0 416 400.251V112.015a23.88 23.88 0 0 0-13.2-21.435M384 384.37L210.881 256.133L384 127.9ZM96 88h32v336H96z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mediaStepBackward
